<!--suppress HtmlFormInputWithoutLabel -->
<template>
    <div>
        <slot name="label">
            <label class="flex justify-start items-end truncate" v-if="withLabel" :for="id" :class="inputLabelClassList">
                <span>{{ inputLabel }}</span>
            </label>
        </slot>
        <div :class="inputWrapperClassList">
            <textarea :id="id"
                      class="overflow-y-auto overscroll-none scrollbar-thin scrollbar-track-gray-100 scrollbar-thumb-indigo-100"
                      :rows="rows"
                      autocomplete="off"
                      :class="[inputClassList,  resizable ? 'resize' :'resize-none']"
                      :placeholder="placeholder"
                      :value="value"
                      :maxlength="maxLength"
                      @input="handleChange">
            </textarea>
            <div v-if="hasErrorIcon && hasErrors" class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                <svg class="h-5 w-5 text-red-500" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                          clip-rule="evenodd"/>
                </svg>
            </div>
        </div>
        <slot name="errorMessage"></slot>
    </div>
</template>

<script>
export default {
    name: "text-area",

    props: {
        id: {
            type: String,
            required: false,
            default: () => (Math.random() * 99999).toFixed(0)
        },
        type: {
            type: String,
            required: false,
            default: "text"
        },
        value: {
            required: true,
            default: ""
        },
        rows: {
            required: false,
            default: 10
        },
        withLabel: {
            type: Boolean,
            required: false,
            default: true,
        },
        inputLabel: {
            type: String,
            required: () => this.withLabel == true
        },
        placeholder: {
            type: String,
            required: false,
            default: ""
        },
        resizable: {
            required: false,
            type: Boolean,
            default: true
        },
        maxLength: {
            required: false,
            type: Number,
            default: 999999
        },
        hasErrors: {
            type: Boolean,
            default: false,
            required: false
        },
        hasErrorIcon: {
            type: Boolean,
            default: true,
            required: false
        },
        inputLabelClassList: {
            type: String,
            required: false,
            default: "block text-sm font-medium leading-5 text-gray-700"
        },
        inputWrapperClassList: {
            type: String,
            required: false,
            default: "mt-1 relative rounded-md shadow-sm"
        },
        inputClassList: {
            type: String,
            required: false,
            default: function () {
                let classList = "focus:ring-indigo-600 focus:border-indigo-600 mt-1 block w-full sm:text-sm border-gray-300 rounded";
                if (this.hasErrors) {
                    classList += " border-red-300 focus:ring focus:ring-red-400";
                }
                return classList;
            }
        }
    },
    methods: {
        handleChange (e) {
            this.$emit("input", e.target.value);
        }
    }
};
</script>

<style scoped>

</style>
